import { render, staticRenderFns } from "./DotList.vue?vue&type=template&id=cb258c98&scoped=true"
import script from "./DotList.vue?vue&type=script&lang=js"
export * from "./DotList.vue?vue&type=script&lang=js"
import style0 from "./DotList.vue?vue&type=style&index=0&id=cb258c98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb258c98",
  null
  
)

export default component.exports